const API_BASE_URL = "https://api.dswustudent.kr";

export const getFileUrl = (url) => {
  if (!url) return "";

  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("data:") ||
    url.startsWith("blob:")
  ) {
    return url;
  }

  if (url.startsWith("/")) {
    return `${API_BASE_URL}${url}`;
  }

  return `${API_BASE_URL}/${url}`;
};

export const apiClient = async (url, options = {}) => {
  const token = localStorage.getItem("accessToken");
  const isFormData = options.body instanceof FormData;

  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  const text = await response.text();

  let result = null;

  try {
    result = text ? JSON.parse(text) : null;
  } catch {
    throw new Error("서버 응답 형식이 올바르지 않습니다.");
  }

  if (!response.ok) {
    throw new Error(result?.message || "요청 처리 중 오류가 발생했습니다.");
  }

  return result;
};

export const publicApiClient = async (url, options = {}) => {
  const isFormData = options.body instanceof FormData;

  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...options.headers,
    },
  });

  const text = await response.text();

  let result = null;

  try {
    result = text ? JSON.parse(text) : null;
  } catch {
    throw new Error("서버 응답 형식이 올바르지 않습니다.");
  }

  if (!response.ok) {
    throw new Error(result?.message || "요청 처리 중 오류가 발생했습니다.");
  }

  return result;
};